export const handleAsync = async <T>(fn: () => Promise<T>): Promise<[string | null, T | null]> => {
  try {
    return [null, await fn()];
  } catch (err: any) {
    return [err.message || 'Operation failed', null];
  }
};

export const simulateDelay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
